import { deleteOrNop, setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/session";
/**
 * Reducer for health check session state
 */
export const sessionReducer = {
    reducers: {
        [actions.setHealthCheckResult]: (state, payload) => {
            const { checkId, result } = payload;
            const timestamp = Date.now();
            const newState = setSafe(state, ["results", checkId], result);
            return setSafe(newState, ["lastFullRun"], timestamp);
        },
        [actions.clearHealthCheckResult]: (state, payload) => {
            return deleteOrNop(state, ["results", payload]);
        },
        [actions.clearAllHealthCheckResults]: (state) => {
            return setSafe(state, ["results"], {});
        },
        [actions.setHealthCheckRunning]: (state, payload) => {
            const { checkId, running } = payload;
            const currentRunning = state.runningChecks || [];
            if (running && !currentRunning.includes(checkId)) {
                return setSafe(state, ["runningChecks"], [...currentRunning, checkId]);
            }
            else if (!running && currentRunning.includes(checkId)) {
                return setSafe(state, ["runningChecks"], currentRunning.filter((id) => id !== checkId));
            }
            return state;
        },
        [actions.setModFiles]: (state, payload) => {
            const { modId, files } = payload;
            return setSafe(state, ["modFiles", modId], files);
        },
        [actions.setModFilesLoading]: (state, payload) => {
            const { modId, loading } = payload;
            const currentLoading = state.loadingModFiles || [];
            if (loading && !currentLoading.includes(modId)) {
                return setSafe(state, ["loadingModFiles"], [...currentLoading, modId]);
            }
            else if (!loading && currentLoading.includes(modId)) {
                return setSafe(state, ["loadingModFiles"], currentLoading.filter((id) => id !== modId));
            }
            return state;
        },
    },
    defaults: {
        results: {},
        runningChecks: [],
        lastFullRun: 0,
        modFiles: {},
        loadingModFiles: [],
    },
};
